import { FC } from 'react';
import { parseISO, format } from 'date-fns';
import styles from './ReviewCard.module.scss';

interface IReviewCard {
  name: string;
  message: string;
  date: string;
}

const ReviewCard: FC<IReviewCard> = ({ name, message, date }) => {
  return (
    <div className={styles.reviewsBlock__item}>
      <div className={styles.reviewsBlock__author}>
        <div className={styles.reviewsBlock__userName}>{name}</div>
        <div className={styles.reviewsBlock__date}>
          <time dateTime={date}>{format(parseISO(date), 'dd.MM.yy')}</time>
        </div>
      </div>
      <div className={styles.reviewsBlock__desk}>{message}</div>
    </div>
  );
};

export default ReviewCard;
